export default "__VITE_ASSET__CHrQHf6r__"